// Menu.js
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-x: clip;\n  z-index: 1; /* 确保内容在 Vanta 之上 */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: -1; /* 确保背景在最底层 */\n  overflow: hidden;\n  pointer-events: none; /* 禁用鼠标事件，防止影响交互 */\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  background-color: ",
        ";\n  box-shadow: 2px 2px 10px #eeeeee;\n  transform: translate3d(0, 0, 0);\n  padding-left: 16px;\n  padding-right: 16px;\n  position: relative;\n  z-index: 2; /* 使导航在 Vanta 之上 */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: fit-content;\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 2; /* 保证显示在 Vanta 上方 */\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: ",
        ";\n  left: 0;\n  transition: top 0.2s;\n  height: ",
        ";\n  width: 100%;\n  z-index: 20;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  height: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n  width: 100%;\n  z-index: 2; /* 保持顶部横幅显示在其他内容之上 */\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  height: 100vh;\n  flex: 1;\n  z-index: 2;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  z-index: 2;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate3d(0, 0, 0);\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0;\n  width: 100%;\n  margin-bottom: 100px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0;\n  width: 100%;\n  margin-top: 20px;\n  padding: 0 15px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import throttle from "lodash/throttle";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Box } from "../../components/Box";
import Flex from "../../components/Box/Flex";
import Footer from "../../components/Footer";
import { SubMenuItems } from "../../components/SubMenuItems";
import Logo from "./components/Logo";
// import Vanta from './components/Vanta'; // 引入 Sketch 组件作为背景
import { MENU_HEIGHT, MOBILE_MENU_HEIGHT, TOP_BANNER_HEIGHT, TOP_BANNER_HEIGHT_MOBILE } from "./config";
import LangSelector from "../../components/LangSelector/LangSelector";
import { MenuContext } from "./context";
import { useMatchBreakpointsContext } from "../../contexts";
var Wrapper = styled.div.withConfig({
    componentId: "sc-bb66277-0"
})(_templateObject());
// VantaWrapper 包裹 Vanta 组件，使其作为全局背景
var VantaWrapper = styled.div.withConfig({
    componentId: "sc-bb66277-1"
})(_templateObject1());
var StyledNav = styled.nav.withConfig({
    componentId: "sc-bb66277-2"
})(_templateObject2(), MENU_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.nav.background;
});
var HeaderNav = styled.div.withConfig({
    componentId: "sc-bb66277-3"
})(_templateObject3());
var FixedContainer = styled.div.withConfig({
    componentId: "sc-bb66277-4"
})(_templateObject4(), function(param) {
    var showMenu = param.showMenu, height = param.height;
    return showMenu ? 0 : "-".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var TopBannerContainer = styled.div.withConfig({
    componentId: "sc-bb66277-5"
})(_templateObject5(), function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var BodyWrapper = styled(Box).withConfig({
    componentId: "sc-bb66277-6"
})(_templateObject6());
var StyledWrapper = styled.div.withConfig({
    componentId: "sc-bb66277-7"
})(_templateObject7());
var Inner = styled.div.withConfig({
    componentId: "sc-bb66277-8"
})(_templateObject8());
var Xwarn = styled.div.withConfig({
    componentId: "sc-bb66277-9"
})(_templateObject9());
var XwarnMobile = styled.div.withConfig({
    componentId: "sc-bb66277-10"
})(_templateObject10());
var Menu = function(param) {
    var _linkComponent = param.linkComponent, linkComponent = _linkComponent === void 0 ? "a" : _linkComponent, banner = param.banner, rightSide = param.rightSide, isDark = param.isDark, toggleTheme = param.toggleTheme, currentLang = param.currentLang, setLang = param.setLang, cakePriceUsd = param.cakePriceUsd, links = param.links, subLinks = param.subLinks, footerLinks = param.footerLinks, activeItem = param.activeItem, activeSubItem = param.activeSubItem, langs = param.langs, buyCakeLabel = param.buyCakeLabel, children = param.children;
    var ref = useState(true), showMenu = ref[0], setShowMenu = ref[1];
    var ref1 = useMatchBreakpointsContext(), isDesktop = ref1.isDesktop, isMobile = ref1.isMobile;
    var refPrevOffset = useRef("object" === "undefined" ? 0 : window.pageYOffset);
    var topBannerHeight = !isDesktop ? TOP_BANNER_HEIGHT_MOBILE : TOP_BANNER_HEIGHT;
    var totalTopMenuHeight = banner ? MENU_HEIGHT + topBannerHeight : MENU_HEIGHT;
    useEffect(function() {
        var handleScroll = function() {
            var currentOffset = window.pageYOffset;
            var isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight;
            var isTopOfPage = currentOffset === 0;
            if (isTopOfPage) {
                setShowMenu(true);
            } else if (!isBottomOfPage) {
                if (currentOffset < refPrevOffset.current || currentOffset <= totalTopMenuHeight) {
                    setShowMenu(true);
                } else {
                    setShowMenu(false);
                }
            }
            refPrevOffset.current = currentOffset;
        };
        var throttledHandleScroll = throttle(handleScroll, 200);
        window.addEventListener("scroll", throttledHandleScroll);
        return function() {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, [
        totalTopMenuHeight
    ]);
    var homeLink = links.find(function(link) {
        return link.label === "Home";
    });
    var subLinksWithoutMobile = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        if (subLink.label !== "Rank") return !subLink.isMobileOnly;
    });
    var subLinksMobileOnly = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return subLink.isMobileOnly;
    });
    return /*#__PURE__*/ _jsx(MenuContext.Provider, {
        value: {
            linkComponent: linkComponent
        },
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                !location.pathname.startsWith("/home") ? /*#__PURE__*/ _jsxs(FixedContainer, {
                    showMenu: showMenu,
                    height: totalTopMenuHeight,
                    children: [
                        banner && /*#__PURE__*/ _jsx(TopBannerContainer, {
                            height: topBannerHeight,
                            children: banner
                        }),
                        /*#__PURE__*/ _jsxs(StyledNav, {
                            children: [
                                /*#__PURE__*/ _jsx(Logo, {
                                    isDark: isDark,
                                    href: "/home"
                                }),
                                /*#__PURE__*/ _jsx(HeaderNav, {
                                    children: /*#__PURE__*/ _jsx(Flex, {
                                        children: isDesktop ? /*#__PURE__*/ _jsx(SubMenuItems, {
                                            style: {
                                                marginTop: 8
                                            },
                                            items: subLinksWithoutMobile,
                                            activeItem: activeSubItem
                                        }) : null
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Flex, {
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            children: /*#__PURE__*/ _jsx(LangSelector, {
                                                currentLang: currentLang,
                                                langs: langs,
                                                setLang: setLang,
                                                buttonScale: "xs",
                                                color: "textSubtle",
                                                hideLanguage: true
                                            })
                                        }),
                                        rightSide
                                    ]
                                })
                            ]
                        })
                    ]
                }) : "",
                !isDesktop ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: subLinks && /*#__PURE__*/ _jsxs(Flex, {
                        style: {
                            zIndex: 2
                        },
                        justifyContent: "space-around",
                        children: [
                            /*#__PURE__*/ _jsx(SubMenuItems, {
                                items: subLinksWithoutMobile,
                                mt: "".concat(totalTopMenuHeight + 1, "px"),
                                activeItem: activeSubItem
                            }),
                            (subLinksMobileOnly === null || subLinksMobileOnly === void 0 ? void 0 : subLinksMobileOnly.length) > 0 && /*#__PURE__*/ _jsx(SubMenuItems, {
                                items: subLinksMobileOnly,
                                mt: "".concat(totalTopMenuHeight + 1, "px"),
                                activeItem: activeSubItem,
                                isMobileOnly: true
                            })
                        ]
                    })
                }) : /*#__PURE__*/ _jsx(StyledWrapper, {
                    style: {
                        height: !location.pathname.startsWith("/home") ? "56px" : 0
                    }
                }),
                /*#__PURE__*/ _jsxs(BodyWrapper, {
                    mt: isDesktop && !location.pathname.startsWith("/home") && !location.pathname.startsWith("/swap") && !location.pathname.startsWith("/earn") ? "".concat(totalTopMenuHeight + 56, "px") : "0",
                    children: [
                        /*#__PURE__*/ _jsx(Inner, {
                            isPushed: false,
                            showMenu: showMenu,
                            children: children
                        }),
                        !location.pathname.startsWith("/home") ? /*#__PURE__*/ _jsx(Footer, {
                            items: footerLinks,
                            isDark: isDark,
                            toggleTheme: toggleTheme,
                            langs: langs,
                            setLang: setLang,
                            currentLang: currentLang,
                            cakePriceUsd: cakePriceUsd,
                            buyCakeLabel: buyCakeLabel,
                            mb: [
                                "".concat(MOBILE_MENU_HEIGHT, "px"),
                                null,
                                "0px"
                            ]
                        }) : ""
                    ]
                })
            ]
        })
    });
};
export default Menu;
